export default function Bayer() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 58 58"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 10.0583C32.95 10.5083 33.25 11.1083 33.25 11.7833C33.25 13.1333 32.2 14.1833 30.85 14.1833H25.375V6.30834H30.775C32.05 6.30834 33.1 7.35834 33.1 8.63334C33.025 9.15834 32.8 9.68334 32.5 10.0583ZM27.175 9.30834H30.475C30.85 9.30834 31.15 9.00834 31.15 8.63334C31.15 8.25834 30.85 7.95834 30.475 7.95834H27.175V9.30834ZM27.175 12.4583H30.55C31 12.4583 31.3 12.1583 31.3 11.7083C31.3 11.2583 31 10.9583 30.55 10.9583H27.175V12.4583Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.775 23.5583H31.75L31.15 22.2083H26.725L26.125 23.5583H24.1L28 15.6833H29.8L33.775 23.5583ZM28.9 17.7083L27.55 20.5583H30.25L28.9 17.7083Z"
        fill="currentColor"
      />
      <path
        d="M31.6 25.2833H33.85L29.875 30.3833V33.1583H28V30.3833L24.025 25.2833H26.275L28.975 28.8833L31.6 25.2833Z"
        fill="currentColor"
      />
      <path
        d="M42.025 25.2833V27.0083H36.775V28.3583H41.875V30.0833H36.775V31.5833H42.025V33.3083H34.9V25.2833H42.025Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.8 30.1583H46.375V33.1583H44.5V25.2833H49.3C50.65 25.2833 51.7 26.4083 51.7 27.7583C51.7 28.8833 50.95 29.7833 49.975 30.0833L52.3 33.1583H50.05L47.8 30.1583ZM49.15 26.9333H46.45V28.4333H49.15C49.6 28.4333 49.9 28.0583 49.9 27.6833C49.9 27.3083 49.525 26.9333 49.15 26.9333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.85 33.1583H22.825L22.225 31.8083H17.8L17.2 33.1583H15.175L19.15 25.2833H20.95L24.85 33.1583ZM19.975 27.3083L18.625 30.1583H21.4L19.975 27.3083Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.375 29.0333C13.825 29.4833 14.125 30.0833 14.125 30.7583C14.125 32.1083 13.075 33.1583 11.725 33.1583H6.17502V25.2833H11.575C12.85 25.2833 13.9 26.3333 13.9 27.6083C13.9 28.1333 13.675 28.6583 13.375 29.0333ZM8.05002 28.2833H11.35C11.725 28.2833 12.025 27.9833 12.025 27.6083C12.025 27.2333 11.725 26.9333 11.35 26.9333H8.05002V28.2833ZM8.05002 31.4333H11.425C11.875 31.4333 12.175 31.1333 12.175 30.6833C12.175 30.2333 11.875 29.9333 11.425 29.9333H8.05002V31.4333Z"
        fill="currentColor"
      />
      <path
        d="M32.5 34.8083V36.5333H27.25V37.8833H32.35V39.6083H27.25V41.1083H32.5V42.8333H25.375V34.8083H32.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3 52.5083V44.6333H30.55C31.9 44.6333 32.95 45.7583 32.95 47.1083C32.95 48.1583 32.35 48.9833 31.45 49.3583L33.85 52.5083H31.6L29.35 49.5083H27.175V52.5083H25.3ZM31.15 47.0333C31.15 46.5833 30.85 46.2833 30.4 46.2833H27.175V47.7833H30.4C30.85 47.7833 31.15 47.4833 31.15 47.0333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.325 27.5333C56.425 12.6833 44.05 0.833344 28.9 0.833344C13.75 0.833344 1.37502 12.6833 0.475024 27.5333C0.475024 28.1333 0.550024 28.7333 0.625024 29.3333C0.550024 28.7333 0.475024 28.1333 0.475024 27.6083C0.475024 27.9083 0.456274 28.2083 0.437524 28.5083C0.418774 28.8083 0.400024 29.1083 0.400024 29.4083C0.400024 29.9333 0.400024 30.5333 0.475024 31.1333C1.37502 45.9833 13.75 57.8333 28.9 57.8333C44.05 57.8333 56.425 45.9833 57.325 31.1333C57.325 30.5568 57.2558 29.9802 57.1838 29.4037C57.2558 29.9801 57.325 30.5539 57.325 31.0583C57.325 30.7584 57.3438 30.4585 57.3625 30.1586C57.3813 29.8586 57.4 29.5583 57.4 29.2583C57.4 28.7333 57.4 28.1333 57.325 27.5333ZM28.9 4.35834C15.7 4.35834 4.90002 14.6333 4.00002 27.5333C3.92502 28.1333 3.92502 28.7333 3.92502 29.3333C3.92502 29.9333 3.92502 30.5333 4.00002 31.1333C4.90002 44.0333 15.7 54.3083 28.9 54.3083C42.1 54.3083 52.9 44.1083 53.8 31.1333C53.875 30.5334 53.875 29.9334 53.875 29.3335C53.875 28.7335 53.875 28.1333 53.8 27.5333C52.9 14.6333 42.1 4.35834 28.9 4.35834Z"
        fill="currentColor"
      />
    </svg>
  );
}
